import { motion } from "framer-motion";
import React, { useState } from "react";
import { addNewTrainer, getAllTrainers } from "../../api";
import {
  BsGithub,
  FaEnvelope,
  FaInstagram,
  FaLinkedin,
  FaPhoneAlt,
  FaUserAlt,
} from "../../assets/icons";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import { buttonClick } from "../../utils/animations";
import { InputField } from "../Others";
import ImageUploader from "./ImageUploader";

const NewTrainer = () => {
  const [trainerName, setTrainerName] = useState("");
  const [imageDownloadUrl, setImageDownloadUrl] = useState(null);
  const [trainerContactNumber, setTrainerContactNumber] = useState("");
  const [trainerInstaProfile, setTrainerInstaProfile] = useState("");
  const [trainerGitProfile, setTrainerGitProfile] = useState("");
  const [trainerLinkindProfile, setTrainerLinkindProfile] = useState("");
  const [trainerEmail, setTrainerEmail] = useState("");
  const [{ alertState, alertType }, dispatch] = useStateValue();

  const saveNewTrainer = () => {
    const data = {
      name: trainerName,
      thumb: imageDownloadUrl,
      email: trainerEmail,
      contact: trainerContactNumber,
      instagram: trainerInstaProfile,
      github: trainerGitProfile,
      linkedin: trainerLinkindProfile,
    };

    if (!trainerName || !imageDownloadUrl || !trainerEmail) {
      dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "warning" });
      dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

      setTimeout(() => {
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
        dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
      }, 3000);
    } else {
      addNewTrainer(data).then((resp) => console.log(resp));
      setTrainerName("");
      setTrainerEmail("");
      setImageDownloadUrl(null);
      setTrainerContactNumber("");
      setTrainerInstaProfile("");
      setTrainerGitProfile("");
      setTrainerLinkindProfile("");

      getAllTrainers().then((trainer) => {
        dispatch({ type: actionType.SET_TRAINERS, allTrainers: trainer.data });
      });

      dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "success" });
      dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

      setTimeout(() => {
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
        dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
      }, 3000);
    }
  };

  return (
    <div className=" w-full p-4 flex  items-center justify-center flex-1">
      <div className=" w-full sm:w-[750px] border border-gray-300 p-4 rounded-md flex flex-col gap-4 items-start justify-center">
        <InputField
          icon={<FaUserAlt className="-rotate-0" />}
          name="Trainer Name"
          stateFunc={setTrainerName}
          stateValue={trainerName}
          key="Trainer_name"
        />

        <div className=" w-full flex items-center justify-start">
          <p className="text-lg font-semibold text-textColor">
            Trainer Profile Picture
          </p>
        </div>

        <ImageUploader
          setImageDownloadUrl={setImageDownloadUrl}
          imageDownloadUrl={imageDownloadUrl}
        />

        <InputField
          icon={<FaEnvelope className="-rotate-0" />}
          name="Trainer Email"
          stateFunc={setTrainerEmail}
          stateValue={trainerEmail}
          key="trainer_email"
        />

        <InputField
          icon={<FaPhoneAlt className="-rotate-0" />}
          name="Trainer Concatct Number"
          stateFunc={setTrainerContactNumber}
          stateValue={trainerContactNumber}
          key="contact_number"
        />

        <InputField
          icon={<FaInstagram className="-rotate-0" />}
          name="Instagram Profile"
          stateFunc={setTrainerInstaProfile}
          stateValue={trainerInstaProfile}
          key="insta_profile"
        />

        <InputField
          icon={<BsGithub className="-rotate-0" />}
          name="Github Profile"
          stateFunc={setTrainerGitProfile}
          stateValue={trainerGitProfile}
          key="github_profile"
        />

        <InputField
          icon={<FaLinkedin className="-rotate-0" />}
          name="LinkedIn Profile"
          stateFunc={setTrainerLinkindProfile}
          stateValue={trainerLinkindProfile}
          key="linkedin_profile"
        />

        <div className="my-4 mb-8 w-full flex items-center justify-center">
          <motion.button
            {...buttonClick}
            className="px-8 py-2 w-full sm:w-300 hover:shadow-md hover:bg-emerald-500  rounded-md bg-emerald-400 text-lg uppercase font-semibold text-white"
            onClick={saveNewTrainer}
          >
            Save
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default NewTrainer;
